import React from 'react';
import PropTypes from 'prop-types';
import './Chart.css';

/**
 * Metric grid for dashboards / queues.
 * layout: auto (wrap) | row (equal flex cards)
 * density: comfortable | compact
 */
export function StatGrid({
  children,
  layout = 'auto',
  density = 'comfortable',
  className = '',
  ...props
}) {
  return (
    <div
      className={[
        'onyx-stat-grid',
        layout !== 'auto' ? `onyx-stat-grid--${layout}` : '',
        density !== 'comfortable' ? `onyx-stat-grid--${density}` : '',
        className,
      ].filter(Boolean).join(' ')}
      data-testid="onyx-stat-grid"
      data-layout={layout}
      data-density={density}
      {...props}
    >
      {children}
    </div>
  );
}

StatGrid.propTypes = {
  children: PropTypes.node,
  layout: PropTypes.oneOf(['auto', 'row']),
  density: PropTypes.oneOf(['comfortable', 'compact']),
  className: PropTypes.string,
};

export function Stat({
  value,
  label,
  density = 'comfortable',
  as: Component = 'div',
  className = '',
  ...props
}) {
  return (
    <Component
      className={[
        'onyx-stat',
        density !== 'comfortable' ? `onyx-stat--${density}` : '',
        className,
      ].filter(Boolean).join(' ')}
      data-testid="onyx-stat"
      data-density={density}
      {...props}
    >
      <span className="onyx-stat__value">{value}</span>
      {label ? <span className="onyx-stat__label">{label}</span> : null}
    </Component>
  );
}

Stat.propTypes = {
  value: PropTypes.node,
  label: PropTypes.node,
  density: PropTypes.oneOf(['comfortable', 'compact']),
  as: PropTypes.elementType,
  className: PropTypes.string,
};
